import React from 'react';
import { Button } from 'semantic-ui-react';
import { ChildrenPropType } from '../../../../../../services/proptypes';
import Icon from '../../../Icon/Icon';
import Trigger from '../Trigger';
import { DIRECTION_BACKWARD } from '../Trigger/Trigger.constants';
import './PreviousTrigger.less';
var defaultProps = {
  content: /*#__PURE__*/React.createElement(Button, {
    icon: true
  }, /*#__PURE__*/React.createElement(Icon, {
    iconName: "arrow-left"
  })),
  onClick: function onClick() {}
};
export default function PreviousTrigger(_ref) {
  var content = _ref.content,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Trigger, {
    content: content,
    onClick: onClick,
    direction: DIRECTION_BACKWARD
  });
}
PreviousTrigger.defaultProps = defaultProps;